module.exports = __webpack_public_path__ + "img/icon-Notas-Selecionadas.823a63e0.svg";